module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/seller/sub-component/kitchen/kitchen.component.scss
// module id = ./src/app/seller/sub-component/kitchen/kitchen.component.scss
// module chunks = main